import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { CustomHandler } from "@sunSource/Store/CustomHandlerCreator";

type HandlerType = CustomHandler<{ isPaymentMethodName: string | undefined | "" }>;

export const DispatchOnePageCheckoutCustomNotes: HandlerType = props => {
    props.dispatch({
        type: "Pages/OnePageCheckout/payementName",
        isPaymentMethodName: props.parameter.isPaymentMethodName,
    });
};

export const chain = [DispatchOnePageCheckoutCustomNotes];

const OnePageCheckoutCustomNotesHandler = createHandlerChainRunner(chain, "OnePageCheckout");
export default OnePageCheckoutCustomNotesHandler;
